import axios from '../AxiosInstance';
import { getApiUrl } from '../../utils/ApiUtils';

// GDPR art. 15 — Subject Access Request (right to data portability)
export const exportEmployeeData = (companyId, employeeId) =>
  axios.get(
    getApiUrl(`${companyId}/hr/employees/${employeeId}/gdpr/export`),
    { withCredentials: true },
  );

// GDPR art. 17 — Right to erasure (irreversible)
export const anonymizeEmployee = (companyId, employeeId, data) =>
  axios.post(
    getApiUrl(`${companyId}/hr/employees/${employeeId}/gdpr/anonymize`),
    data,
    { withCredentials: true },
  );
